import cx from "classnames";
import { memo } from "react";

import type { ArgumentTypeChoices, DisputeType } from "../LienTypes";

export const DISPUTE_TYPE_COLORS: Record<DisputeType, string> = {
  UNRELATED: "red",
  POST_ORM_TERM: "yellow",
  POST_TPOC: "pink",
  NON_PRIMARY_ICD: "orange",
  DENIED: "green",
  NON_COVERED_SERVICE: "blue",
  LEGAL_ARGUMENT: "purple",
  HARDSHIP_WAIVER_EQUITY: "brown",
} as const;

type DisputeIconProps = {
  type: ArgumentTypeChoices;
  hasArgument: boolean;
  onDisputeClick: (type: DisputeType) => void;
};

export const DisputeIcon = memo(
  ({ type, hasArgument, onDisputeClick }: DisputeIconProps) => (
    <div
      className={cx(
        "material-icons dispute-icon",
        DISPUTE_TYPE_COLORS[type.value as DisputeType],
        { active: hasArgument },
      )}
      onClick={(e) => {
        e.stopPropagation();
        onDisputeClick(type.value as DisputeType);
      }}
      role="button"
      tabIndex={0}
    >
      done
    </div>
  ),
);

DisputeIcon.displayName = "DisputeIcon";

type DisputeLegendProps = {
  disputeTypes: ArgumentTypeChoices[];
};

export const DisputeLegend = memo(({ disputeTypes }: DisputeLegendProps) => (
  <div className="liens-legend">
    {disputeTypes
      .filter((type) => type.value !== null)
      .map((type) => (
        <div key={type.value}>
          <figure className={DISPUTE_TYPE_COLORS[type.value as DisputeType]} />
          <label>{type.label}</label>
        </div>
      ))}
  </div>
));

DisputeLegend.displayName = "DisputeLegend";
